export enum ProviderType {
    fileUploader = "fileUploader",
    googleDrive = "googleDrive",
    oneDrive = "oneDrive"
}
